import React from 'react'
import Link from './Link'
import Image from './Image'

import Placeholder from '../../assets/images/placeholder-logo.svg'
import Headline from './Headline'
import FadeInBottomEffect from '../effect/FadeInBottomEffect'

import { useTranslation } from 'react-i18next'

const ArticleStackedTeaser = ({ item, className }) => {
  const { t } = useTranslation()

  let fullSlug = item.full_slug ? item.full_slug : item.node?.full_slug
  let name = item.name ? item.name : item.node?.name
  let content
  if (item.content) {
    content = JSON.parse(item.content)
  } else if (item.node?.content) {
    content = JSON.parse(item.node?.content)
  }

  return (
    <FadeInBottomEffect
      className={`stacked-teaser-item article-stacked-teaser-item ${
        className ? className : ''
      }`}
      tagName="section"
    >
      <article>
        <Link link={`/${fullSlug}`}>
          <div
            className={`teaser-item-image${
              content?.header_image ? '' : '-placeholder'
            }`}
          >
            <Image
              image={content?.header_image ? content.header_image : Placeholder}
              alt={name}
              title={name}
              imageWidth="360"
              imageHeight="360"
            />
          </div>

          <div className="teaser-item-content">
            {content?.category && (
              <p className="meta-category">
                {`${t(`articles.categories.${content.category}`)}`}
              </p>
            )}
            <Headline tagName="h3" headline_level="h3" headline={name} />
            {content?.teaser?.length > 0 && (
              <p className="teaser-item-text">{content.teaser}</p>
            )}
          </div>
        </Link>
      </article>
    </FadeInBottomEffect>
  )
}

export default ArticleStackedTeaser
